export const CLIENT_ID = 'bcbs-wyoming-web';
/**
 * @deprecated TEMPORARY while we transition from client-set TenantID to server-set
 */
export const TENANT_ID = 'bcbs-wyoming';

// Mobile app URLs
export const APP_STORE_PROD_URL =
  'https://apps.apple.com/us/app/bcbswy/id1658570173';
export const PLAY_STORE_PROD_URL =
  'https://play.google.com/store/apps/details?id=com.highmark.bcbswy';

export const AUTH0_BCBS_CONNECTION = 'bcbs-wyoming';

// E-Bill service constants
export const E_BILL_SERVICE_NAME = 'E-Bill';
export const USER_REGISTERED_FOR_EBILL_TOKEN = 'Y';
